/* Pulse size recommender: "Shoes I already own" on the size guide page.
   Approved design and decisions: docs/handoffs/2026-09-11-size-guide-reco-proof.md
   Logic spec: docs/specs/2026-09-10-size-recommender-design.md (proof + tests: preview/size-reco/)

   Our own sizes are NEVER stored here. Both charts come from the page's [data-psg-data]
   block, which the section fills from shop.metafields.custom.size_chart_new / _original,
   so a chart edit in the metafield flows straight through. Other brands come from
   assets/pulse-size-brands.js (generated), loaded the first time someone reaches for the step.

   The foot-length path stays with assets/pulse-size-guide.js; this file wires the "How to measure" jump.

   ONE QUESTION AT A TIME (Andre, 2026-09-13, "apply this to the size chart page as well"), the PDP drawer's
   flow: brand (1), women's or men's (2, its own dropdown, BEFORE the size), size (3), each opening when the one
   above is answered, then the fit/width/second-pair questions and an answer card. "Measure my foot" is foot
   length (1), women's or men's (2), card; the measuring itself is still pulse-size-guide.js, which announces
   each outcome as `psg:answer`. One women's/men's answer serves both paths and sets window.PulseSizeScale. */
(function () {
  var root = document.querySelector('[data-reco]');
  if (!root) return;
  var psg = root.closest('[data-psg]');
  if (!psg) return;
  var dataEl = psg.querySelector('[data-psg-data]');
  var chart;
  try { chart = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!chart || !Array.isArray(chart['new']) || !chart['new'].length) return;

  /* ---------- numbers ---------- */
  function lab(v) {
    if (v === null || v === undefined || v === '') return '';
    var f = parseFloat(v);
    if (isNaN(f) || String(v).indexOf('-') > 0) return String(v);
    return String(f);
  }
  function mm(cm) { return Math.round(parseFloat(cm) * 10); }
  /* a Pulse row is a band (previous maximum, this maximum] in millimetres */
  function pulseRows(rows) {
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i], hi = mm(r.cm);
      var lo = i ? out[i - 1].hi : hi - (rows.length > 1 ? mm(rows[1].cm) - hi : 4);
      out.push({ usm: lab(r.usm), usw: lab(r.usw), uk: lab(r.uk), eu: lab(r.eu), lo: lo, hi: hi });
    }
    return out;
  }
  var PULSE = { 'new': pulseRows(chart['new']), original: Array.isArray(chart.original) ? pulseRows(chart.original) : [] };

  /* ---------- words (2026-09-15): the storefront's language from snippets/pulse-size-i18n.liquid, this English if absent ---------- */
  var T = (function () {
    var en = { original_range: "Pulse Dance Shoes' original range (Flow or Bianco)", original_note: 'The size you bought in Flow or Bianco.',
      card_title: 'Your Pulse Dance Shoes size', card_women: "Women's US [size]", card_men: "Men's US [size]", card_select: 'Select [size]',
      group_dance: 'Dance brands', group_other: 'All other brands', group_all: 'Brands', tag_ours: 'ours', tag_dance: 'dance',
      size_select: 'Select your size', size_select_in: 'Select your size in [brand]', size_choose: 'Choose', pick_brand_first: 'Pick a brand first',
      size_in_them: 'Your size in them', size_on_box: 'The size printed on the box', fit_q: 'How do they fit you?',
      fit_q_named: 'How does your [shoe] fit you?', women_lower: "women's", men_lower: "men's", box_use: 'Use [label].',
      wide_line: 'For a wider fit, choose Flow 2 Wide in the same size: a true 2E width with added volume around the toe box, so it has more room across the ball of the foot and toes.',
      measure_rather: 'We would rather measure than guess.', pairs_disagree: 'Those two pairs point to different feet.',
      covers_three: 'That size covers three of ours.', enter_length: 'Enter your foot length and we will give you an exact size.',
      smaller: 'That is smaller than our smallest size.', larger: 'That is larger than our largest size.',
      double_check: 'Measure your foot to double-check.', not_on_file: 'We do not have that size on file for [brand] yet.',
      measure_exact: 'Measure your foot and we will give you an exact size.', measure_instead: 'Measure my foot instead',
      drawer_covers_three: 'That size covers three of our sizes, so measure your foot instead.',
      drawer_not_on_file: 'We do not have that [brand] size yet.', sold_out: 'Sold out',
      ratio_line: 'Your width is [ratio]% of your foot length.', verdict_tag: 'Your fit', verdict_h: 'Two sizes will fit you',
      border_intro: 'That is right on the line between our regular fit and our wide fit, so either will work. Choose by how you like a shoe to feel.',
      opt_up: 'Regular fit, half a size up', opt_regular: 'Regular fit, your size', opt_wide: 'Your size in a wide fit', or_word: 'or',
      card_show: 'Shop my size', recommended_size: 'Recommended size', recommended_fit: 'Recommended fit', also_fits: 'Also consider',
      two_options: 'You have two size options', border_short: 'Your foot sits between our regular and wide fit, so either will work.',
      line_regular: 'Regular fit', line_wide: 'Wide fit', feel_snug: 'A more supportive fit', feel_roomy: 'For more space across the toe and heel',
      youre_regular: "You're a regular fit", youre_wide: "You're a wide fit",
      tag_roomy: 'Roomier fit', tag_snug: 'Snugger fit', b_roomy: 'A more forgiving fit, with extra room around the toes',
      b_snug: 'A slimmer profile and a snug fit', b_top: "Your foot is at the top of your size, so the half size up won't feel long",
      avail_wide: 'Available in Flow 2 Wide', avail_reg: 'Available in Flow 2, Nova or Volt',
      sgb_skipped: 'Skipped', sgb_q_size: 'What size are they?', sgb_q_size_named: 'What size are your [brand]?',
      sgb_res_empty: 'Answer the questions to see it', sgb_m0: 'Not started', sgb_m1: 'Good starting point', sgb_m2: 'Great match', sgb_m3: 'Closest fit',
      sgb_tip_start: 'Three quick taps for a size. Measuring takes it further.', sgb_tip_brand: 'Measure your foot to make this your closest fit.',
      sgb_tip_changed: 'Your foot length points to a different size than your [brand] size. Go with this one.', sgb_tip_length: 'From your foot length. Add your width for your closest fit.',
      sgb_tip_measured: 'From your foot length and width.', sgb_tip_wide: "You're a wide fit, so this is Flow 2 Wide in your size.",
      sgb_tip_two: 'Two sizes fit you. See both options below.', sgb_res_two: 'Two options', notes: {}, box: {} };
    var el = psg.querySelector('[data-pulse-size-i18n]'), got = {};
    try { if (el) got = JSON.parse(el.textContent) || {}; } catch (e) {}
    for (var k in got) if (Object.prototype.hasOwnProperty.call(got, k) && got[k]) en[k] = got[k];
    return en;
  })();
  function tf(tpl, map) { return String(tpl).replace(/\[(\w+)\]/g, function (w, k) { return Object.prototype.hasOwnProperty.call(map, k) ? String(map[k]) : w; }); }
  /* "Nike men's 9", "Bloch 7": the shoe named in the fit question, in the order the English always used */
  function shoeName(brand, sys, men, shown) {
    var parts = [brand.name];
    if (sys === 'us') parts.push(men ? T.men_lower : T.women_lower); else if (sys) parts.push(sys.toUpperCase());
    parts.push(shown);
    return parts.join(' ');
  }

  /* ---------- brands ---------- */
  var brands = [], byName = {}, ordered = [], loaded = false, loading = false, waiters = [];
  function addBrand(b) {
    brands.push(b);
    byName[b.name.toLowerCase()] = b;
    for (var i = 0; i < b.aliases.length; i++) byName[b.aliases[i].toLowerCase()] = b;
  }
  /* our original range as a brand, from the live chart: repeat customers get their new-range size the same way */
  if (PULSE.original.length) {
    var lad = { women: [], men: [] };
    PULSE.original.forEach(function (r) {
      lad.women.push({ label: r.usw, lo: r.lo, hi: r.hi, sys: { us: r.usw, uk: r.uk, eu: r.eu } });
      lad.men.push({ label: r.usm, lo: r.lo, hi: r.hi, sys: { us: r.usm, uk: r.uk, eu: r.eu } });
    });
    var origAliases = ['Pulse', 'Pulse Dance Shoes', 'Flow', 'Flow original', 'Bianco', 'Flow White', 'Flow Black', 'Flow Onyx'];
    origAliases.push('Flow or Bianco (our original range)');
    if (T.original_range !== "Pulse Dance Shoes' original range (Flow or Bianco)") origAliases.push("Pulse Dance Shoes' original range (Flow or Bianco)");
    addBrand({ id: 'pulse-original', name: T.original_range, group: 'pulse', sizing: 'us', box_label: '',
      note: T.original_note, systems: ['us', 'uk', 'eu'], ladders: lad,
      aliases: origAliases });
  }
  function unpack(list) {
    list.forEach(function (x) {
      var rows = function (a) { return (a || []).map(function (r) { return { label: r[0], lo: r[1], hi: r[2], sys: { us: r[3], uk: r[4], eu: r[5] } }; }); };
      addBrand({ id: x[0], name: x[1], aliases: x[2], group: x[3] === 'd' ? 'dance' : 'street', sizing: x[4], box_label: T.box[x[0]] || x[5], note: T.notes[x[0]] || x[6], systems: x[7],
        ladders: { women: rows(x[8].w), men: rows(x[8].m) } });
    });
    var rank = { pulse: 0, dance: 1, street: 1 }; /* dance brands fold into the list (Andre, 2026-10-19) */
    ordered = brands.slice().sort(function (a, b) {
      if (rank[a.group] !== rank[b.group]) return rank[a.group] - rank[b.group];
      return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' });
    });
  }
  function loadBrands(cb) {
    if (loaded) { if (cb) cb(); return; }
    if (cb) waiters.push(cb);
    if (loading) return;
    loading = true;
    var s = document.createElement('script');
    s.src = root.getAttribute('data-brands-src');
    s.async = true;
    s.onload = function () {
      unpack(window.PulseSizeBrands || []); loaded = true;
      var w = waiters; waiters = []; w.forEach(function (f) { f(); });
    };
    s.onerror = function () { loading = false; };
    document.head.appendChild(s);
  }
  ordered = brands.slice();
  /* fetch the list the moment someone heads for the step, before they type */
  root.addEventListener('pointerover', function () { loadBrands(); }, { once: true });
  root.addEventListener('focusin', function () { loadBrands(); }, { once: true });

  /* ---------- the logic (tested in preview/size-reco/test_reco.mjs) ---------- */
  function findBrand(id) { for (var i = 0; i < brands.length; i++) if (brands[i].id === id) return brands[i]; return null; }
  function ladderRow(brand, sc, label) {
    var l = (brand.ladders && (brand.ladders[sc] && brand.ladders[sc].length ? brand.ladders[sc] : (brand.ladders.women.length ? brand.ladders.women : brand.ladders.men))) || [];
    for (var i = 0; i < l.length; i++) if (l[i].label === String(label).trim()) return l[i];
    return null;
  }
  function overlap(a, b) { return Math.max(0, Math.min(a.hi, b.hi) - Math.max(a.lo, b.lo)); }
  function narrowBand(band, fit) {
    var w = band.hi - band.lo;
    if (fit === 'tight') return { lo: band.hi - Math.max(1, Math.round(w / 3)), hi: band.hi };
    if (fit === 'roomy') return { lo: band.lo, hi: band.lo + Math.max(1, Math.round(w / 3)) };
    return { lo: band.lo, hi: band.hi };
  }
  function intersect(a, b) { var lo = Math.max(a.lo, b.lo), hi = Math.min(a.hi, b.hi); return hi > lo ? { lo: lo, hi: hi } : null; }
  function recommend(input) {
    var rows = PULSE['new'];
    var brand = findBrand(input.brand), wide = input.width === 'wide';
    if (!brand) return { status: 'unknown', row: null, wide: false };
    var first = ladderRow(brand, input.scale, input.label);
    if (!first) return { status: 'unknown', row: null, wide: wide };
    var band = narrowBand({ lo: first.lo, hi: first.hi }, input.fit);
    if (input.second && input.second.brand) {
      var b2 = findBrand(input.second.brand), r2 = b2 && ladderRow(b2, input.second.scale, input.second.label);
      if (r2) {
        var both = intersect(band, { lo: r2.lo, hi: r2.hi });
        if (!both) return { status: 'measure', row: null, reason: 'disagree', wide: wide };
        band = both;
      }
    }
    var c = rows.filter(function (r) { return overlap(r, band) > 0; });
    if (!c.length) return { status: 'out', row: null, reason: band.hi <= rows[0].lo ? 'smaller than our smallest size' : 'larger than our largest size', wide: wide };
    if (c.length === 1) return { status: 'match', row: c[0], wide: wide };
    if (c.length >= 3) return { status: 'measure', row: null, reason: 'spans', wide: wide };
    var a = c[0], b = c[1], oa = overlap(a, band), ob = overlap(b, band), row;
    if (input.fit === 'tight') row = b;
    else if (input.fit === 'roomy') row = a;
    else row = oa > ob ? a : b;   /* ties go to the larger */
    return { status: 'between', row: row, wide: wide };
  }

  /* ---------- the cards (OPTION B, 2026-10-24) ----------
     Andre chose "Start easy, then sharpen" (preview/size-guide-redesign/). One list of question cards replaces the two
     modes: 1 women's or men's, 2 the sneakers they wear, 3 their size in them (with the fit, width and second-pair
     questions as before), 4 measure for the closest fit. One live result with a three-step meter: a brand size is a
     good starting point, a foot length a great match, length and width the closest fit. The foot length answer wins
     over the brand answer. recommend(), widthFit() and the verdict cards above are unchanged. */
  /* a page cached before Option B (up to ~30 minutes) has no cards: leave its finder to pulse-size-guide.js rather than throw */
  if (!root.querySelector('[data-sgb-card]')) return;
  function $(sel) { return root.querySelector(sel); }
  var brandIn = $('[data-reco-brand]'), sizeSel = $('[data-reco-size]'), sizeLabel = $('[data-reco-sizelabel]'), note = $('[data-reco-brandnote]');
  var brandIn2 = $('[data-reco-brand2]'), sizeSel2 = $('[data-reco-size2]');
  var state = { brand: null, gender: '', label: '', fit: 'right', width: '', ball: 'no', brand2: null, label2: '', skipBrand: false, skipMeasure: false, open: '' };
  var fResult = psg.querySelector('[data-reco-fresult]'), footInput = psg.querySelector('[data-psg-input]');
  var widthField = psg.querySelector('[data-reco-widthfield]'), widthIn = psg.querySelector('[data-reco-fwidth]');
  var res = { size: $('[data-sgb-size]'), sub: $('[data-sgb-sub]'), meter: $('[data-sgb-meter]'), mw: $('[data-sgb-mw]'), tip: $('[data-sgb-tip]'), cta: $('[data-sgb-cta]') };
  function cardEl(k) { return root.querySelector('[data-sgb-card="' + k + '"]'); }

  /* "SHOW ME" (Andre, 2026-10-23): the women's or men's collection (or Flow 2 Wide for a wide answer) filtered to that size
     and to what can be bought, in stock or on pre-order. The size filter is Shopify's shoe-size taxonomy, the US men's
     number. The click also keeps the size for product pages (assets/pulse-size-memory.js, [data-size-save]). */
  var TAX = { '4': '17100', '4.5': '2940', '5': '2941', '5.5': '2942', '6': '17101', '6.5': '2943', '7': '2944', '7.5': '2945',
    '8': '17102', '8.5': '2946', '9': '2947', '9.5': '2948', '10': '17103', '10.5': '3010', '11': '3011', '11.5': '3012',
    '12': '17210', '12.5': '3013', '13': '3014', '13.5': '3015' };
  function showUrl(row, wide) {
    var id = TAX[String(row.usm)]; if (!id) return '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var handle = wide ? 'wide-fit-dance-sneakers' : scale() === 'men' ? 'mens-dance-sneakers' : 'womens-dance-sneakers';
    return root + 'collections/' + handle + '?filter.v.t.shopify.shoe-size=' + encodeURIComponent('gid://shopify/TaxonomyValue/' + id) +
      '&filter.v.m.pulse.availability=In+stock&filter.v.m.pulse.availability=Pre-order';
  }
  function sizeText(row) { var men = scale() === 'men'; return tf(men ? T.card_men : T.card_women, { size: men ? row.usm : row.usw }); }
  /* the call to action: the same link and size-memory attributes the answer card has always carried */
  function showLink(row, wide, range) {
    var href = showUrl(row, wide), a;
    if (href) { a = document.createElement('a'); a.href = href; } else { a = document.createElement('button'); a.type = 'button'; }
    a.className = 'sgb-cta';
    a.setAttribute('data-size-save', ''); a.setAttribute('data-range', range || 'new');
    a.setAttribute('data-usm', row.usm); a.setAttribute('data-usw', row.usw);
    a.textContent = tf(href ? T.card_show : T.card_select, { size: sizeText(row) });
    return a;
  }
  /* the verdict's option cards (two sizes fit) are built like the old answer card */
  function card(row, note, range, wide, fitLine, bannerText, bannerKind) {
    var c = document.createElement('div'); c.className = 'pss-card pss-card--rec';
    var k = document.createElement('span'); k.className = 'sdr-banner sdr-banner--' + (bannerKind || 'rec'); k.textContent = bannerText || T.recommended_size;
    var v = document.createElement('span'); v.className = 'pss-card__v'; v.textContent = sizeText(row);
    var sub = document.createElement('span'); sub.className = 'pss-card__s'; sub.textContent = 'UK ' + row.uk + ' · EU ' + row.eu;
    c.appendChild(k);
    if (fitLine) { var y = document.createElement('span'); y.className = 'sdr-youre'; y.textContent = fitLine; c.appendChild(y); }
    c.appendChild(v); c.appendChild(sub);
    if (note) { var n = document.createElement('span'); n.className = 'pss-card__note'; n.textContent = note; c.appendChild(n); }
    var save = showLink(row, wide, range); save.className = 'pss-card__cta'; c.appendChild(save);
    return c;
  }
  function footRange() {
    var on = psg.querySelector('[data-psg-range].is-on');
    var r = (on && on.getAttribute('data-psg-range')) || psg.getAttribute('data-default-range') || 'new';
    return r === 'wide' ? 'new' : r;   /* the Wide chart shares the current range's sizes (2026-10-23) */
  }

  function scale() { if (state.gender) return state.gender; return psg.getAttribute('data-psg-scale') === 'men' ? 'men' : 'women'; }
  function resolveBrand(text) { return byName[String(text || '').trim().toLowerCase()] || null; }

  function combobox(input, onPick) {
    var list = input.parentNode.querySelector('.reco__list'), items = [], active = -1;
    function norm(s) { return String(s || '').toLowerCase().trim(); }
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function open() { if (items.length) { list.hidden = false; input.setAttribute('aria-expanded', 'true'); } else close(); }
    function setActive(i) {
      active = i;
      var opts = list.querySelectorAll('.reco__item');
      for (var k = 0; k < opts.length; k++) opts[k].classList.toggle('is-active', k === i);
      if (opts[i]) opts[i].scrollIntoView({ block: 'nearest' });
    }
    function pick(b) { input.value = b.name; close(); onPick(b); }
    function filter() {
      if (!loaded) { loadBrands(filter); }
      var q = norm(input.value);
      var qw = q.split(/\s+/).filter(Boolean);
      /* every word they type must start a word somewhere in the brand's name or aliases, so "pulse dance shoes flow" finds our original range */
      function words(b) { if (!b._w) b._w = [b.name].concat(b.aliases).join(' ').toLowerCase().split(/[\s.\-()]+/).filter(Boolean); return b._w; }
      var found = ordered.filter(function (b) { if (!qw.length) return true; var ws = words(b); return qw.every(function (x) { return ws.some(function (w) { return w.indexOf(x) === 0; }); }); });
      var dance = found.filter(function (b) { return b.group === 'pulse'; });
      var rest = found.filter(function (b) { return b.group !== 'pulse'; });
      items = dance.concat(rest);
      list.innerHTML = '';
      function head(t) { var h = document.createElement('li'); h.className = 'reco__group'; h.setAttribute('role', 'presentation'); h.textContent = t; list.appendChild(h); }
      items.forEach(function (b) {
        if (b === rest[0]) head(dance.length ? T.group_other : T.group_all);
        var li = document.createElement('li'); li.setAttribute('role', 'option'); li.className = 'reco__item';
        var n = document.createElement('span'); n.textContent = b.name; li.appendChild(n);
        if (b.group === 'pulse') { var t = document.createElement('small'); t.textContent = T.tag_ours; li.appendChild(t); }
        li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(b); });
        list.appendChild(li);
      });
      open();
    }
    input.addEventListener('focus', filter);
    input.addEventListener('input', function () { filter(); onPick(resolveBrand(input.value)); });
    input.addEventListener('blur', function () { setTimeout(close, 120); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) filter(); setActive(Math.min(active + 1, items.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, 0)); }
      else if (e.key === 'Enter') { if (!list.hidden && active >= 0) { e.preventDefault(); pick(items[active]); } }
      else if (e.key === 'Escape') { close(); }
    });
  }

  function ladderOf(brand) { var l = brand.ladders; return (l[scale()] && l[scale()].length) ? l[scale()] : (l.women.length ? l.women : l.men); }
  var SYS = { us: 'US', uk: 'UK', eu: 'EU' };
  /* adidas and a few others size EU in thirds: stored 42.67, printed 42 2/3 */
  function thirds(v) { var s = String(v); if (/\.33$/.test(s)) return s.slice(0, -3) + '⅓'; if (/\.67$/.test(s)) return s.slice(0, -3) + '⅔'; return s; }
  function rowText(brand, r) {
    var parts = [];
    if (brand.sizing === 'box') parts.push(brand.name.split(' ')[0] + ' ' + r.label);
    var order = brand.sizing === 'uk' ? ['uk', 'eu', 'us'] : ['us', 'uk', 'eu'];
    order.forEach(function (k) {
      if (!r.sys || !r.sys[k]) return;
      if (brand.sizing === 'box' && r.sys[k] === r.label) return;
      parts.push(SYS[k] + ' ' + thirds(r.sys[k]));
    });
    return parts.length ? parts.join(' · ') : r.label;
  }
  function fillSizes(sel, brand) {
    sel.innerHTML = '';
    var main = sel === sizeSel;
    if (!brand || (main && !state.gender)) { sel.disabled = true; sel.appendChild(new Option(main ? T.size_select : T.pick_brand_first, '')); return; }
    sel.disabled = false;
    sel.appendChild(new Option(main ? tf(T.size_select_in, { brand: brand.name }) : T.size_choose, ''));
    var seen = {};
    ladderOf(brand).forEach(function (r) {
      var t = rowText(brand, r);
      if (seen[t]) return; seen[t] = 1;
      sel.appendChild(new Option(t, r.label));
    });
  }
  function sizeWording(brand) { return brand && brand.sizing === 'box' ? T.size_on_box : T.size_in_them; }
  function systemFor(brand) {
    if (!brand || brand.sizing === 'box') return null;
    var a = brand.systems || [];
    return a.indexOf(brand.sizing) >= 0 ? brand.sizing : (a[0] || null);
  }
  function fitWording() {
    if (!state.brand || !state.label) return T.fit_q;
    var sys = systemFor(state.brand), row = null, l = ladderOf(state.brand);
    for (var i = 0; i < l.length; i++) if (l[i].label === state.label) row = l[i];
    var shown = sys && row && row.sys && row.sys[sys] ? row.sys[sys] : state.label;
    return tf(T.fit_q_named, { shoe: shoeName(state.brand, sys, scale() === 'men', shown) });
  }

  function onBrand() {
    var b = resolveBrand(brandIn.value);
    if (b !== state.brand) { state.brand = b; state.label = ''; }
    if (b) { state.skipBrand = false; if (state.open === 'brand') state.open = ''; }
    fillSizes(sizeSel, state.brand); sizeSel.value = state.label;
    sizeLabel.textContent = sizeWording(state.brand);
    if (state.brand) {
      var bits = [];
      if (state.brand.box_label) bits.push(tf(T.box_use, { label: state.brand.box_label }));
      if (state.brand.note) bits.push(state.brand.note);
      note.textContent = bits.join(' '); note.hidden = !bits.length;
    } else { note.hidden = true; }
    paint();
  }
  function onBrand2() { state.brand2 = resolveBrand(brandIn2.value); fillSizes(sizeSel2, state.brand2); state.label2 = ''; paint(); }
  function setChips(attr, value) {
    var bs = root.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < bs.length; i++) { var on = bs[i].getAttribute(attr) === value; bs[i].classList.toggle('is-on', on); bs[i].setAttribute('aria-pressed', on ? 'true' : 'false'); }
  }
  function widthAnswer() {
    if (state.width === 'wide') return 'wide';
    if (state.width === 'unsure') return state.ball === 'yes' ? 'wide' : 'regular';
    return 'regular';
  }

  var marked = null;   /* the row this script lit for a brand answer; pulse-size-guide.js lights the foot length row itself */
  function unmark() { if (marked) marked.classList.remove('is-match'); marked = null; }
  function markRow(row) {
    unmark();
    var t = psg.querySelector('[data-psg-table="new"]'); if (!t) return;
    var trs = t.querySelectorAll('[data-psg-row]');
    for (var i = 0; i < trs.length; i++) {
      if (lab(trs[i].getAttribute('data-usw')) === row.usw && lab(trs[i].getAttribute('data-usm')) === row.usm) { trs[i].classList.add('is-match'); marked = trs[i]; return; }
    }
  }

  /* ---------- FOOT WIDTH (Andre, 2026-10-20) ----------
     The SAME rule as ~/pulse-project/common/width_fit.py (the support desk and the website chat), on the current
     range's rows. Change the numbers there and here together.
       narrow: width under 35% of the foot length. Regular; half a size down when the foot is within 2 mm over the
               top of the size below, otherwise the chart size (may feel a little roomy, Flow 2 holds it closest)
       regular: width up to 39% of the chart size's longest foot
       up:     too wide for that, foot within 2 mm of the top of its size, width up to 40.9% of the foot length
       wide:   anything else, Flow 2 Wide in the chart size. Never a full size up.
     Customers see their own width as a share of their length (Andre, 2026-10-23), never the cut-offs. */
  var RATIO_REGULAR = 0.39, RATIO_UP = 0.409, RATIO_NARROW = 0.35, NEAR_MM = 2, BORDER_PTS = 1;
  function unitNow() { var on = psg.querySelector('[data-psg-unit].is-on'); return (on && on.getAttribute('data-psg-unit')) || 'cm'; }
  function widthCm() {
    if (!widthIn) return null;
    var v = parseFloat(String(widthIn.value || '').replace(',', '.'));
    if (isNaN(v) || v <= 0) return null;
    var cm = Math.round((unitNow() === 'in' ? v * 2.54 : v) * 10) / 10;
    return cm >= 6 && cm <= 14 ? cm : null;    /* a foot width, not a typo */
  }
  function widthFit(row, cmLen, cmWid, usual) {
    var rows = PULSE['new'], i = -1;
    for (var k = 0; k < rows.length; k++) if (rows[k].usw === lab(row.usw) && rows[k].usm === lab(row.usm)) { i = k; break; }
    if (i < 0 || !cmLen || !cmWid) return null;
    var lmm = Math.round(cmLen * 10), wmm = Math.round(cmWid * 100) / 10, top = rows[i].hi;
    var below = i > 0 ? lmm - rows[i - 1].hi : null;
    if (wmm < RATIO_NARROW * lmm) {
      if (below !== null && below <= NEAR_MM) return { fit: 'down', row: rows[i - 1], from: rows[i - 1] };
      return { fit: 'narrow', row: rows[i] };
    }
    var atTop = top - lmm <= NEAR_MM && i + 1 < rows.length, w;
    if (wmm <= RATIO_REGULAR * top + 1e-9) w = { fit: 'regular', row: rows[i] };
    else if (atTop && wmm <= RATIO_UP * lmm + 1e-9) w = { fit: 'up', row: rows[i + 1], from: rows[i] };
    else w = { fit: 'wide', row: rows[i] };
    /* BORDERLINE (Andre, 2026-10-23: "if they're borderline, explain to them they essentially have two options"):
       up to BORDER_PTS percentage points OVER the line that decided Wide, offer both, Wide first. Under the line the
       answer is regular only (Andre, 2026-10-24: 26 x 10.1 cm is never a Wide). At the top of a size that line is RATIO_UP of the length (regular half up or Wide); otherwise
       RATIO_REGULAR of the size's longest foot (regular or Wide, same size). */
    var up = { fit: 'up', row: rows[i + 1], from: rows[i] }, reg = { fit: 'regular', row: rows[i] }, wide = { fit: 'wide', row: rows[i] };
    /* Usually buys WIDE (Andre, 2026-10-24): up to BORDER_PTS points UNDER the line also gets both, Wide first; over the
       line, Wide alone; clearly regular stays regular. Same rule as pulse_common.width_fit. */
    var over = atTop ? (wmm / lmm - RATIO_UP) * 100 : (wmm / top - RATIO_REGULAR) * 100;
    if (usual === 'wide') { if (w.fit === (atTop ? 'up' : 'regular') && over >= -BORDER_PTS - 1e-9) w = { fit: 'wide', row: rows[i], border: [wide, atTop ? up : reg], off: over }; }
    else if (w.fit === 'wide' && over <= BORDER_PTS + 1e-9) { w.border = atTop ? [wide, up] : [wide, reg]; w.off = over; }
    w.ratio = wmm / lmm * 100;
    return w;
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  /* TWO OPTIONS, simplified (Andre, 2026-10-23): a heading, one line, then two cards, OR between. */
  function verdict(w) {
    var v = el('section', 'pss-verdict');
    v.appendChild(el('h3', 'pss-verdict__h', T.two_options));
    v.appendChild(el('p', 'pss-verdict__p', T.border_short));
    for (var o = 0; o < w.border.length; o++) {
      if (o) { var or = el('div', 'pss-or'); or.appendChild(el('span', '', T.or_word)); v.appendChild(or); }
      v.appendChild(optionCard(w.border[o], o === 0));
    }
    return v;
  }
  function optionCard(opt, first) {
    var roomy = opt.fit === 'wide';
    var line = { regular: T.line_regular, wide: T.line_wide }[opt.fit] || T.line_regular;
    var c = card(opt.row, '', 'new', roomy, line, first ? (T.option_1 || T.recommended_fit) : (T.option_2 || T.also_fits), first ? 'rec' : 'also');
    c.classList.add('sdr-opt');
    c.insertBefore(el('span', 'pss-card__note', roomy ? T.feel_roomy : T.feel_snug), c.querySelector('.pss-card__cta'));
    return c;
  }

  /* ---------- paint: the cards and the live result from one state ---------- */
  var foot = { state: 'hint', row: null, cm: null };
  function setCard(k, mode, val) {
    var c = cardEl(k); if (!c) return;
    c.classList.toggle('is-done', mode === 'done'); c.classList.toggle('is-locked', mode === 'locked');
    var v = c.querySelector('[data-sgb-val]'); if (v) v.textContent = mode === 'done' ? (val || '') : (val && k === 'measure' ? val : '');
    var e = c.querySelector('[data-sgb-edit]'); if (e) e.hidden = mode !== 'done';
  }
  function meter(level) { res.meter.setAttribute('data-level', String(level)); res.mw.textContent = T['sgb_m' + level] || ''; }
  function brandLabel() { return state.brand ? state.brand.name : ''; }
  function paint() {
    var g = state.gender;
    /* cards */
    /* question 1 is answered once they pick BOTH women's or men's and the fit they usually buy (Andre, 2026-10-24) */
    var ok1 = !!(g && (state.width || !root.querySelector('[data-sgb-width]')));   /* a cached page without the fit buttons still works */
    var gchip = g ? root.querySelector('[data-sgb-gender="' + g + '"]') : null, wchip = state.width ? root.querySelector('[data-sgb-width="' + state.width + '"]') : null;
    setCard('gender', ok1 && state.open !== 'gender' ? 'done' : 'open', gchip && wchip ? gchip.textContent.trim() + ' · ' + wchip.textContent.trim() : '');
    setCard('brand', !ok1 ? 'locked' : (state.open === 'brand' || (!state.brand && !state.skipBrand)) ? 'open' : 'done', state.brand ? state.brand.name : T.sgb_skipped);
    setCard('size', ok1 && state.brand ? 'open' : 'locked');
    var sq = root.querySelector('[data-sgb-sizeq]'); if (sq) sq.textContent = state.brand && state.brand.id !== 'pulse-original' ? tf(T.sgb_q_size_named, { brand: state.brand.name }) : T.sgb_q_size;
    setChips('data-sgb-gender', g); setChips('data-sgb-width', state.width);
    var chipIds = root.querySelectorAll('[data-sgb-brand]'), onChip = false;
    for (var i = 0; i < chipIds.length; i++) { var on = !!state.brand && chipIds[i].getAttribute('data-sgb-brand') === state.brand.id; chipIds[i].classList.toggle('is-on', on); if (on) onChip = true; }
    var other = root.querySelector('[data-sgb-other]'); if (other) other.classList.toggle('is-on', !!state.brand && !onChip);

    /* the size card's own questions, as before */
    var ready = !!(state.brand && ok1 && state.label);
    $('[data-reco-q="fit"]').hidden = !ready;
    $('[data-reco-q="second"]').hidden = !ready;
    $('[data-reco-fitlabel]').textContent = fitWording();
    sizeSel.classList.toggle('is-done', ready);

    /* the brand answer */
    var r = null;
    if (ready) {
      r = recommend({ brand: state.brand.id, scale: scale(), label: state.label, fit: state.fit, width: widthAnswer(),
        second: state.brand2 && state.label2 ? { brand: state.brand2.id, scale: scale(), label: state.label2 } : null });
      track('brand', r);
    } else if (window.PulseSizeTrack) PulseSizeTrack.record('guide-brand', null);

    /* the foot answer */
    var isNew = footRange() === 'new' && !!widthIn;
    if (widthField) widthField.hidden = !isNew;
    var wcm = isNew ? widthCm() : null;
    if (widthIn) widthIn.classList.toggle('is-done', !!wcm);
    var footOk = foot.state === 'match' && !!foot.row;
    if (footInput) footInput.classList.toggle('is-done', footOk);
    /* the measure step can be skipped once the brand answer has a size (Andre, 2026-10-25) */
    var mSkipped = !!(ok1 && r && r.row && state.skipMeasure && !footOk && state.open !== 'measure');
    var mSkip = root.querySelector('[data-sgb-skipmeasure]'); if (mSkip) mSkip.hidden = !(r && r.row && !footOk);
    if (mSkipped) setCard('measure', 'done', T.sgb_skipped); else setCard('measure', ok1 ? 'open' : 'locked', footOk && foot.cm ? (unitNow() === 'in' ? (foot.cm / 2.54).toFixed(1) + ' in' : foot.cm.toFixed(1) + ' cm') : '');
    var w = footOk && isNew && wcm ? widthFit(foot.row, foot.cm, wcm, state.width) : null;

    /* the live result */
    while (fResult.firstChild) fResult.removeChild(fResult.firstChild);
    while (res.cta.firstChild) res.cta.removeChild(res.cta.firstChild);
    res.size.classList.remove('is-empty', 'is-text');
    root.classList.toggle('has-answer', !!((footOk && ok1) || r));
    if (footOk && ok1) {
      unmark();
      if (w && w.border) {
        res.size.textContent = T.sgb_res_two; res.size.classList.add('is-text'); res.sub.textContent = T.border_short;
        meter(3); res.tip.textContent = T.sgb_tip_two;
        fResult.appendChild(verdict(w));
      } else {
        var row = w ? w.row : foot.row, wide = !!w && w.fit === 'wide';
        var changed = r && r.row && r.row.usm !== row.usm;
        res.size.textContent = sizeText(row); res.sub.textContent = 'UK ' + row.uk + ' · EU ' + row.eu + (wide ? ' · Flow 2 Wide' : '');
        meter(wcm ? 3 : 2);
        res.tip.textContent = wide ? T.sgb_tip_wide : changed ? tf(T.sgb_tip_changed, { brand: brandLabel() }) : wcm ? T.sgb_tip_measured : T.sgb_tip_length;
        res.cta.appendChild(showLink(row, wide, footRange()));
      }
      track('measure', w, wcm);
    } else if (r && r.row) {
      markRow(r.row);
      res.size.textContent = sizeText(r.row); res.sub.textContent = 'UK ' + r.row.uk + ' · EU ' + r.row.eu;
      meter(1); res.tip.textContent = r.wide ? T.wide_line : T.sgb_tip_brand;
      res.cta.appendChild(showLink(r.row, r.wide, 'new'));
    } else if (r) {
      unmark();
      res.size.textContent = T.measure_rather; res.size.classList.add('is-text');
      res.sub.textContent = r.status === 'measure' ? (r.reason === 'disagree' ? T.pairs_disagree : T.covers_three)
        : r.status === 'out' ? (r.reason === 'smaller than our smallest size' ? T.smaller : T.larger) : tf(T.not_on_file, { brand: brandLabel() });
      meter(0); res.tip.textContent = r.status === 'out' ? T.double_check : r.status === 'measure' ? T.enter_length : T.measure_exact;
      var m = el('button', 'sgb-cta', T.measure_instead); m.type = 'button';
      m.addEventListener('click', toMeasure); res.cta.appendChild(m);
    } else {
      unmark();
      res.size.textContent = '–'; res.size.classList.add('is-empty');
      res.sub.textContent = T.sgb_res_empty; meter(0); res.tip.textContent = T.sgb_tip_start;
    }
  }

  function track(kind, x, wcm) {
    if (!window.PulseSizeTrack) return;
    var t = PulseSizeTrack, ctx = t.context();
    if (kind === 'brand') {
      var r = x, sc = scale() === 'men' ? "men's" : "women's", fsys = systemFor(state.brand), frow = null, fl = ladderOf(state.brand);
      for (var k = 0; k < fl.length; k++) if (fl[k].label === state.label) frow = fl[k];
      var theirs = state.brand.name + ' ' + (fsys === 'us' ? sc + ' US ' : fsys ? fsys.toUpperCase() + ' ' : '') + (fsys && frow && frow.sys && frow.sys[fsys] ? frow.sys[fsys] : state.label);
      var two = state.brand2 && state.label2 ? state.brand2.name + ' ' + state.label2 : '';
      var ours = r.row ? t.pulseSize(r.row, scale()) : (r.status === 'measure' ? 'asked to measure' : r.status === 'out' ? 'outside our range' : 'size not on file');
      t.record('guide-brand', {
        surface: 'size guide', method: 'shoes I already own', market: ctx.market, product: ctx.product,
        brand: state.brand.name, brand_size: theirs, scale: scale(), fit: state.fit || 'right', width: widthAnswer(),
        second_pair: two, status: r.status, pulse_size: ours,
        pulse_us_women: r.row ? r.row.usw : '', pulse_us_men: r.row ? r.row.usm : '', pulse_uk: r.row ? r.row.uk : '', pulse_eu: r.row ? r.row.eu : '',
        summary: theirs + (two ? ' + ' + two : '') + ', fits ' + (state.fit || 'right') + (widthAnswer() === 'wide' ? ', wide' : '') + ' -> Pulse ' + ours + ' (size guide)'
      });
    } else if (x && wcm) {
      var w = x, ours2 = t.pulseSize(w.row, state.gender);
      t.record('size guide-measure', {
        surface: 'size guide', method: 'measure my foot', market: ctx.market, product: ctx.product,
        foot_length: foot.cm.toFixed(1) + ' cm', foot_cm: foot.cm, width: wcm.toFixed(1) + ' cm', fit: w.fit, scale: state.gender, status: 'match', pulse_size: ours2,
        pulse_us_women: w.row.usw, pulse_us_men: w.row.usm, pulse_uk: w.row.uk, pulse_eu: w.row.eu,
        summary: 'Foot ' + foot.cm.toFixed(1) + ' x ' + wcm.toFixed(1) + ' cm -> Pulse ' + ours2 + (w.fit === 'wide' ? ' Flow 2 Wide' : '') + ', ' + w.fit + ' (size guide)'
      });
    }
  }

  function toMeasure() {
    var c = cardEl('measure'); if (!c) return;
    c.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (footInput) setTimeout(function () { try { footInput.focus({ preventScroll: true }); } catch (e) { footInput.focus(); } }, 350);
  }

  if (widthIn) {
    widthIn.addEventListener('input', paint);
    var ub = psg.querySelectorAll('[data-psg-unit]');
    for (var q = 0; q < ub.length; q++) ub[q].addEventListener('click', function () {
      widthIn.placeholder = widthIn.getAttribute(this.getAttribute('data-psg-unit') === 'in' ? 'data-ph-in' : 'data-ph-cm') || widthIn.placeholder;
      setTimeout(paint, 0);
    });
  }
  psg.addEventListener('psg:answer', function (e) { foot.state = e.detail.state; foot.row = e.detail.row; foot.cm = e.detail.cm; paint(); });
  function setGender(v) {
    state.gender = v === 'men' ? 'men' : v === 'women' ? 'women' : '';
    if (state.open === 'gender' && state.width) state.open = '';
    /* the chart shows both US columns until this is answered (2026-10-24) */
    if (state.gender) psg.setAttribute('data-psg-picked', ''); else psg.removeAttribute('data-psg-picked');
    if (state.gender && window.PulseSizeScale) window.PulseSizeScale.set(state.gender);
    var keepL = state.label; fillSizes(sizeSel, state.brand); if (state.brand) { sizeSel.value = keepL; state.label = sizeSel.value; } else state.label = '';
    paint();
  }

  /* ---------- events ---------- */
  var gb = root.querySelectorAll('[data-sgb-gender]');
  for (var gi = 0; gi < gb.length; gi++) gb[gi].addEventListener('click', function () { setGender(this.getAttribute('data-sgb-gender')); });
  var bb = root.querySelectorAll('[data-sgb-brand]');
  for (var bi = 0; bi < bb.length; bi++) bb[bi].addEventListener('click', function () {
    var id = this.getAttribute('data-sgb-brand');
    var go = function () { var b = findBrand(id); if (!b) return; brandIn.value = b.name; root.querySelector('[data-sgb-otherbox]').hidden = true; if (brandSel) brandSel.value = ''; onBrand(); };
    if (findBrand(id)) go(); else loadBrands(go);
  });
  /* ANOTHER BRAND IS A SCROLL LIST (Andre, 2026-10-24: "prevent the keyboard from coming up"): a native select, so a phone
     opens its picker wheel instead of a keyboard. Our original range first, then every brand A to Z. The hidden search box
     still carries the chosen name, which is what onBrand() reads. */
  var otherBtn = root.querySelector('[data-sgb-other]'), brandSel = root.querySelector('[data-sgb-brandselect]'), brandSelFilled = false;
  function fillBrandSelect() {
    if (!brandSel || brandSelFilled || !loaded) return;
    brandSelFilled = true;
    var ours = ordered.filter(function (b) { return b.group === 'pulse'; }), rest = ordered.filter(function (b) { return b.group !== 'pulse'; });
    function group(label, list) { if (!list.length) return; var g = document.createElement('optgroup'); g.label = label; list.forEach(function (b) { g.appendChild(new Option(b.name, b.id)); }); brandSel.appendChild(g); }
    group(T.tag_ours, ours); group(ours.length ? T.group_other : T.group_all, rest);
    if (state.brand) brandSel.value = state.brand.id;
  }
  if (otherBtn) otherBtn.addEventListener('click', function () { root.querySelector('[data-sgb-otherbox]').hidden = false; loadBrands(fillBrandSelect); fillBrandSelect(); });
  if (brandSel) brandSel.addEventListener('change', function () { var b = findBrand(brandSel.value); brandIn.value = b ? b.name : ''; onBrand(); });
  var skip = root.querySelector('[data-sgb-skip]');
  if (skip) skip.addEventListener('click', function () { state.skipBrand = true; state.brand = null; state.label = ''; state.open = ''; brandIn.value = ''; fillSizes(sizeSel, null); paint(); toMeasure(); });
  var skipM = root.querySelector('[data-sgb-skipmeasure]');
  if (skipM) skipM.addEventListener('click', function () {
    state.skipMeasure = true; if (state.open === 'measure') state.open = ''; paint();
    var rb = root.querySelector('[data-sgb-res]');
    if (rb) rb.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  });
  var edits = root.querySelectorAll('[data-sgb-edit]');
  for (var ei = 0; ei < edits.length; ei++) edits[ei].addEventListener('click', function () { state.open = this.closest('[data-sgb-card]').getAttribute('data-sgb-card'); paint(); });
  combobox(brandIn, onBrand);
  sizeSel.addEventListener('change', function () { state.label = sizeSel.value; paint(); });
  combobox(brandIn2, onBrand2);
  sizeSel2.addEventListener('change', function () { state.label2 = sizeSel2.value; paint(); });
  function chipGroup(attr, key) {
    var bs = root.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < bs.length; i++) bs[i].addEventListener('click', function () { state[key] = this.getAttribute(attr); setChips(attr, state[key]); paint(); });
  }
  chipGroup('data-reco-fit', 'fit');
  var wb = root.querySelectorAll('[data-sgb-width]');
  for (var wi = 0; wi < wb.length; wi++) wb[wi].addEventListener('click', function () {
    state.width = this.getAttribute('data-sgb-width'); if (state.open === 'gender' && state.gender) state.open = ''; paint();
  });
  $('[data-reco-addsecond]').addEventListener('click', function (e) { e.currentTarget.hidden = true; $('[data-reco-secondrow]').hidden = false; brandIn2.focus(); });
  /* the women's/men's scale changed somewhere else (it is site-wide): refill both size lists, keep a size the other ladder also has */
  new MutationObserver(function () {
    if (state.gender) state.gender = psg.getAttribute('data-psg-scale') === 'men' ? 'men' : 'women';
    function keep(sel, l) { var ok = false; for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === l) ok = true; sel.value = ok ? l : ''; return ok ? l : ''; }
    fillSizes(sizeSel, state.brand); state.label = keep(sizeSel, state.label);
    fillSizes(sizeSel2, state.brand2); state.label2 = keep(sizeSel2, state.label2);
    sizeLabel.textContent = sizeWording(state.brand);
    paint();
  }).observe(psg, { attributes: true, attributeFilter: ['data-psg-scale'] });

  /* tabs: Find my size and Size chart. The chart stays on the page under the finder; the tab is a quick way down to it
     and lights while the chart is in view. */
  var charts = psg.querySelector('.psg__charts'), tabs = root.querySelectorAll('[data-sgb-tab]');
  function tabOn(t) { for (var i = 0; i < tabs.length; i++) { var on = tabs[i].getAttribute('data-sgb-tab') === t; tabs[i].classList.toggle('is-on', on); tabs[i].setAttribute('aria-pressed', on ? 'true' : 'false'); } }
  for (var ti = 0; ti < tabs.length; ti++) tabs[ti].addEventListener('click', function () {
    var t = this.getAttribute('data-sgb-tab'), target = t === 'chart' ? charts : root;
    if (target) target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  /* on a phone the result rides at the foot of the screen while the questions are in view */
  /* the keyboard is up while a box in the cards has focus: the bar steps aside so it never covers what they type */
  root.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input')) root.classList.add('is-typing'); });
  root.addEventListener('focusout', function () { setTimeout(function () { var a = document.activeElement; if (!(a && root.contains(a) && a.matches('input'))) root.classList.remove('is-typing'); }, 50); });
  var cardsBox = root.querySelector('.sgb-cards'), ticking = false;
  function onScroll() {
    ticking = false;
    var vh = window.innerHeight, cr = cardsBox.getBoundingClientRect();
    root.classList.toggle('is-bar', cr.top < vh * 0.85 && cr.bottom > vh * 0.35);
    if (charts) tabOn(charts.getBoundingClientRect().top < vh * 0.5 ? 'chart' : 'find');
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', onScroll);

  /* "HOW TO MEASURE" OPENS INLINE (Andre, 2026-10-20: "appear underneath ... like a dropdown section rather than
     pushing people to the bottom of the page", then "show on the same page ... length on the left and width on the
     right"). The measuring guide's [data-how-body] is lifted out of the section at the foot of the page into a panel
     right under the button, both guides side by side, and put back on close so the section is whole again (search,
     scripts off). The guide for the field the customer was last in is lit. Esc closes. */
  var how = psg.querySelector('[data-reco-how]');
  var howHead = psg.querySelector('template[data-how-head]');
  var howBody = psg.querySelector('[data-how-body]');
  if (how && howHead && howBody) (function () {
    var home = howBody.parentNode, homeNext = howBody.nextSibling, section = home.closest('.psg__measure');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)');
    var panel = document.createElement('div'), clip = document.createElement('div'), card = document.createElement('div');
    panel.className = 'reco__howpanel'; panel.id = 'reco-howpanel-' + (how.getAttribute('href') || '').replace(/\W/g, '');
    panel.setAttribute('role', 'region'); panel.hidden = true;
    clip.className = 'reco__howclip'; card.className = 'reco__howcard';
    card.appendChild(howHead.content.cloneNode(true)); clip.appendChild(card); panel.appendChild(clip);
    how.insertAdjacentElement('afterend', panel);
    how.setAttribute('role', 'button'); how.setAttribute('aria-expanded', 'false'); how.setAttribute('aria-controls', panel.id);
    panel.setAttribute('aria-label', how.textContent.trim());
    var panes = howBody.querySelectorAll('[data-how-pane]');
    var lastField = '';
    function light() {
      for (var j = 0; j < panes.length; j++) panes[j].classList.toggle('is-lit', !!lastField && panes[j].getAttribute('data-how-pane') === lastField);
    }
    psg.addEventListener('focusin', function (e) {
      if (!e.target.matches || !e.target.matches('input')) return;
      lastField = (e.target.id || '').indexOf('fwidth') !== -1 ? 'width' : (e.target.closest('.reco__footstep') ? 'length' : lastField);
      if (how.getAttribute('aria-expanded') === 'true') light();
    });
    function open() {
      card.querySelector('.reco__howhead').insertAdjacentElement('afterend', howBody);
      if (section) section.hidden = true;
      light();
      panel.hidden = false; how.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-open'); }); });
    }
    function close(focusBack) {
      panel.classList.remove('is-open'); how.setAttribute('aria-expanded', 'false');
      var done = function () {
        if (panel.classList.contains('is-open')) return;
        panel.hidden = true; home.insertBefore(howBody, homeNext);
        for (var j = 0; j < panes.length; j++) { panes[j].classList.remove('is-lit'); panes[j].removeAttribute('data-hl-on'); }
        /* the guide no longer shows under the chart (Andre, 2026-10-23), so the section stays hidden on close */
      };
      if (reduce.matches) done(); else setTimeout(done, 480);
      if (focusBack) how.focus();
    }
    how.addEventListener('click', function (e) { e.preventDefault(); if (how.getAttribute('aria-expanded') === 'true') close(false); else open(); });
    how.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); how.click(); } });
    card.querySelector('[data-how-close]').addEventListener('click', function () { close(true); });
    psg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && how.getAttribute('aria-expanded') === 'true' && (panel.contains(e.target) || e.target === how)) close(true);
    });
    /* pointing at a width step lights the part of the drawing it is about */
    howBody.addEventListener('pointerover', function (e) {
      var st = e.target.closest && e.target.closest('[data-hl]'); var pane = e.target.closest && e.target.closest('[data-how-pane]');
      if (pane) { if (st) pane.setAttribute('data-hl-on', st.getAttribute('data-hl')); else pane.removeAttribute('data-hl-on'); }
    });
    howBody.addEventListener('pointerleave', function () { for (var j = 0; j < panes.length; j++) panes[j].removeAttribute('data-hl-on'); });
  })();

  /* Option B opens on the first card, women's or men's (2026-10-24); the result starts empty. */
  paint(); onScroll();
})();
